import React, { useEffect, useState } from "react";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls, url } from "../../Utils/url";
import { connect } from "react-redux";
import InnerHeader from "../../Components/Common/InnerHeader";
import Loader from "react-loader-spinner";
import { getBillStatus } from "../Payment/Payment";
import { toast } from "react-toastify";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import { useHistory } from "react-router-dom";

const getReminders = (token, setReminder, setLoading) => {
  ApiCall(
    "get",
    `${urls.GetReminder}`,
    null,
    "get reminders",
    token,
    function (e) {
      setReminder(e.data);
      setLoading(false);
    },
    function (error) {
      setLoading(false);
    }
  );
};

const PayBill = (billId, token, setBillParam, windowVar) => {
  const body = {
    bill_id: billId,
    reminder: 1,
  };
  ApiCall("post", `${urls.Payment}`, body, "payBill", token, function (e) {
    const link = `${url}Payment/${e.data.invoice_number}`;
    // window.open(`${url}Payment/${e.data.invoice_number}`);
    windowVar.location = link;
    setBillParam(billId);
  });
};

const ProfileInfo = ({ name, text }) => {
  return (
    <div>
      <span>{text}</span>
      <span>{name}</span>
    </div>
  );
};
export const CompanyImage = (companyId) => {
  switch (companyId) {
    case 1:
      return require("../../assets/images/Water.png");
    case 2:
      return require("../../assets/images/Gas.png");
    case 3:
      return require("../../assets/images/Electricity.png");
    case 4:
      return require("../../assets/images/MCI.png");
    case 5:
      return require("../../assets/images/Telephone.png");
    default:
      break;
  }
};
const CompanyText = (companyId, data) => {
  switch (companyId) {
    case 1:
      return data.info.CustomerName || data.info.OwnerName;
    case 2:
      return data.info.CustomerName || data.info.OwnerName;
    case 3:
      return data.info.CustomerName || data.info.OwnerName;
    case 4:
      return "همراه اول";
    case 5:
      return "تلفن ثابت";
    default:
      break;
  }
};
const ReminderComponent = ({ bill, token, setBillParam, index }) => {
  return (
    <div
      className="ReminderComponentContainer"
      id="Billhistory"
      key={index}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <div className="ReminderComponentContainerInner">
        <div className="CompanyImageHistory">
          <img src={CompanyImage(bill.bill_company_id)} alt="" />
        </div>

        <div>
          <ProfileInfo name={"شماره"} text={bill.parameter} />
          <ProfileInfo
            name={"نوع قبض"}
            text={bill.end_of_period === 1 ? "پایان دوره" : "میان دوره"}
          />
          <ProfileInfo
            name={"مبلغ"}
            text={` ${bill.amount.toLocaleString()} ریال`}
          />
          <ProfileInfo name={"شناسه قبض"} text={bill.bill_id} />
        </div>
      </div>

      {!bill.payment_status || bill.payment_status === 0 ? (
        <div
          className="LoginButton bottomBtn"
          onClick={() => {
            var windowVar = window.open();
            PayBill(bill.id, token, setBillParam, windowVar);
          }}
        >
          پرداخت
        </div>
      ) : (
        <div className="LoginButton bottomBtn isPaid">
          <span>پرداخت شده</span>
        </div>
      )}
    </div>
  );
};
function WaitingForPay({ ...props }) {
  const [reminders, setReminders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState(0);
  const [windowFocused, setWindowFocused] = useState(true);
  const [billParam, setBillParam] = useState("");
  const history = useHistory();
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      history.push("/addtohome");
    } else if (!props.isLogin) {
      history.push("/login");
    }
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    (window.orientation == 90 || window.orientation == -90) &&
      isMobile &&
      history.push("/rotate");
    window.addEventListener(
      "orientationchange",
      function () {
        var isForbidden =
          (window.orientation == 90 || window.orientation == -90) && isMobile;
        if (isForbidden) {
          history.push("/rotate");
        }
      },
      false
    );
  }, []);
  useEffect(() => {
    window.navigator.onLine &&
      props.isLogin &&
      getReminders(props.token, setReminders, setLoading);
  }, []);
  useEffect(() => {
    !window.navigator.onLine && toast.warn("دستگاه به اینترنت متصل نیست");
  }, []);
  function handleActivity(forcedFlag) {
    if (typeof forcedFlag === "boolean") {
      return forcedFlag ? setWindowFocused(true) : setWindowFocused(false);
    }

    return document.hidden ? setWindowFocused(false) : setWindowFocused(true);
  }
  useEffect(() => {
    document.addEventListener("visibilitychange", handleActivity);
    return () => {
      document.removeEventListener("visibilitychange", handleActivity);
    };
  });
  useEffect(() => {
    billParam && getBillStatus(billParam, props.token, setPaymentStatus);
    if (paymentStatus === 1 && windowFocused) {
      toast.success("پرداخت قبض با موفقیت انجام شد", {
        position: "bottom-center",
      });
    }
  }, [windowFocused, props.token, paymentStatus]);
  return (
    <div className="Container">
      <div
        className="mobileContainer"
        style={{ paddingTop: window.innerHeight * 0.12 }}
      >
        <PhoneHeader text={"در انتظار پرداخت"} />
        {/* <h4 className="historySpan">در انتظار پرداخت</h4> */}
        {loading && (
          <img
            id="loading"
            className="LoadingImage"
            src={require("../../assets/images/Loading.png")}
          />
        )}
        {!loading && reminders.length !== 0 && window.navigator.onLine && (
          <>
            <div className="paymentsContainer" id="paymentsContainer">
              {reminders
                .filter(
                  (i) => i.bill_company_id === 4 || i.bill_company_id === 5
                )
                .map((i, index) => (
                  <ReminderComponent
                    bill={i}
                    index={index}
                    token={props.token}
                    setBillParam={setBillParam}
                  />
                ))}
            </div>
          </>
        )}
        {!loading && reminders.length === 0 && window.navigator.onLine && (
          <div
            style={{
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              width: "100%",
            }}
          >
            <span className="historySpanEmpty">
              !موردی برای نمایش وجود ندارد
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    bills: state.persistedParams.bills,
    token: state.auth.token,
    Open: state.init.loginOpen,
    isLogin: state.auth.isLogin,
  };
};

export default connect(mapStateToProps)(WaitingForPay);
